import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="navbar">  
      <Link to="/">Home</Link>
      <Link to="/projects">Projects</Link>
      <Link to="/portfolio">Portfolio</Link>
      <Link to="/contact">Contact</Link>
      <Link to="/imprint">Imprint</Link>
    </nav>
  );
};

export default Navbar;
